import { ResizePlugin } from 'pixijs/app';
import { loadTextures, loadWebFont } from 'pixijs/assets';
import { extensions, INSTALLED } from 'pixijs/core';
import 'pixijs/display/cache-as-bitmap';
import 'pixijs/display/get-child-by-name';
import 'pixijs/display/get-global-position';
import { NodeCanvasResource } from './adapter';

// Remove the default loader plugins
extensions.remove(
    loadTextures,
    loadWebFont,
    ResizePlugin
);

// reset installed resources and remove resize plugin from Application
INSTALLED.length = 0;
INSTALLED.push(NodeCanvasResource);

// Export ES for those importing specifically by name
export * from './filters';
export * from 'pixijs/app';
export * from 'pixijs/assets';
export * from 'pixijs/core';
export * from 'pixijs/display';
export * from 'pixijs/extract';
export * from 'pixijs/filter/alpha';
export * from 'pixijs/filter/blur';
export * from 'pixijs/filter/color-matrix';
export * from 'pixijs/filter/displacement';
export * from 'pixijs/filter/fxaa';
export * from 'pixijs/filter/noise';
export * from 'pixijs/graphics';
export * from 'pixijs/mesh';
export * from 'pixijs/mesh/extras';
export * from 'pixijs/particle-container';
export * from 'pixijs/prepare';
export * from 'pixijs/sprite';
export * from 'pixijs/sprite-animated';
export * from 'pixijs/sprite-tiling';
export * from 'pixijs/spritesheet';
export * from 'pixijs/text';
export * from 'pixijs/text-bitmap';

// Export adapter
export * from './adapter';
